import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { AccrualPeriod } from '../../data-services';
import { AccrualPeriodModel } from '../../data-services/accrual-period/accrual-period.model';
import { PtoPolicySetup } from '../../data-services/pto-policy/setup';
import { IGroup } from '../../groups/IGroups';
import { UpdateGroups } from '../../groups/store';
import * as fromGroups from '../../groups/store/reducer';
import { SelectItem, Table } from '../../shared';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-setup-presenter',
    templateUrl: './setup-presenter.component.html',
    styleUrls: ['./setup-presenter.component.scss'],
    standalone: false
})
export class SetupPresenterComponent
    extends DisplayErrors<PtoPolicySetup>
    implements OnInit
{
    public editing: PtoPolicySetup = {} as PtoPolicySetup;
    clonedPolicySetup: { [i: string]: PtoPolicySetup } = {};
    @Output() SavePolicySetup = new ReplaySubject<any>(1);
    @Output() DeletePolicySetup = new ReplaySubject<any>(1);

    groupsSelectItem: SelectItem[];
    accrualPeriodsSelectItem: SelectItem[];

    policyFilterSelectItem: SelectItem[];
    @Input() accrualsFilterSelectItem: SelectItem[];

    private PolicySetupSubject = new ReplaySubject<Array<PtoPolicySetup>>(1);
    private _policysetup: Array<PtoPolicySetup>;
    newGroup: {
        Categoryid: string;
        GroupName: string;
        Purpose: string;
        GroupID: any;
    }[];
    @Input() set policySetup(value: Array<PtoPolicySetup>) {
        if (value && value.length > 0) {
            value = value.map(p => ({
                ...p,
                AccrualPeriod: this.findAccrualPeriod(p)
            }));
            this._policysetup = value.sort((a, b) => {
                if (a.PolicyTitle === b.PolicyTitle) {
                    return 0;
                }
                if (typeof a.PolicyTitle === typeof b.PolicyTitle) {
                    return a.PolicyTitle < b.PolicyTitle ? -1 : 1;
                }
                return typeof a.PolicyTitle < typeof b.PolicyTitle ? -1 : 1;
            });

            this.groupsSelectItem = this._policysetup.map(x => ({
                value: x.Groupid,
                label: x.PolicyTitle
            }));
            this.groupsSelectItem = this.groupsSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );

            this.policyFilterSelectItem = this._policysetup.map(x => ({
                value: x.PolicyTitle,
                label: x.PolicyTitle
            }));
            this.policyFilterSelectItem = this.policyFilterSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );
            // this.PolicySetupSubject.next(this._policysetup);
        } else {
            this._policysetup = value;
            // this.PolicySetupSubject.next(this._policysetup);
        }

        // this.cFilterSelectItem = value.map(x => ({
        //     value: x.ContractListID,
        //     label: x.ContractDesc
        // }));
        // this.cFilterSelectItem = this.cFilterSelectItem.filter(
        //     (v, i, a) => a.findIndex(t => t.label === v.label) === i
        // );
    }
    get policySetup(): Array<PtoPolicySetup> {
        return this._policysetup;
    }

    private GroupsSubject = new ReplaySubject<Array<IGroup>>(1);
    private _groups: Array<IGroup>;
    @Input() set groups(value: Array<IGroup>) {
        this._groups = value;
        this.GroupsSubject.next(value);
    }
    get groups(): Array<IGroup> {
        return this._groups;
    }

    private AccrualPeriodSubject = new ReplaySubject<Array<AccrualPeriodModel>>(
        1
    );
    private _accrualperiods: Array<AccrualPeriodModel>;
    @Input() set accrualPeriods(value: Array<AccrualPeriodModel>) {
        if (value && value.length > 0) {
            if (this.policySetup && this.policySetup.length > 0) {
                this.policySetup.forEach(x => {
                    const period = value.find(
                        y => y.AccrueLeavePeriodID == x.AccrualPeriodID
                    );
                    x.AccrualPeriod = period.AccrueLeavePeriod;
                });
                this.PolicySetupSubject.next(this.policySetup);
            }

            this._accrualperiods = value;
            this.AccrualPeriodSubject.next(value);

            this.accrualPeriodsSelectItem = value.map(x => ({
                value: x.AccrueLeavePeriodID,
                label: x.AccrueLeavePeriod
            }));
            this.accrualPeriodsSelectItem =
                this.accrualPeriodsSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
        }
    }
    get accrualPeriods(): Array<AccrualPeriodModel> {
        return this._accrualperiods;
    }

    active = true;
    buttonItems: any;

    policyGroupPlaceholder = 'Policy';

    addFormGroup: UntypedFormGroup;

    hoursAccrued: string;
    vacAccrualMax: string;
    accrualPeriod: any;
    yearsOfServiceEnd: string;
    yearsOfServiceStart: string;
    policyGroup: any;
    policyTitle: string;
    customGroupName: string;
    customGroupOptionSelected = false;

    policyTitleInvalid = false;
    policyGroupInvalid = false;
    yearsOfServiceStartInvalid = false;
    yearsOfServiceEndInvalid = false;
    accrualPeriodInvalid = false;
    hoursAccruedInvalid = false;
    addGroupInvalid = false;
    vacAccrualMaxInvalid = false;

    showDialog = false;
    showGroupNameInput = true;

    showDeleteDialog = false;

    dataForDelete: PtoPolicySetup;

    areYouSureDeleteDesc = 'Are you sure?';

    @ViewChild('SetupTable', { static: true }) SetupTable: Table;

    constructor(
        private store: Store<fromGroups.State>,
        private log: LoggingService
    ) {
        super();
        this.addFormGroup = new UntypedFormGroup({
            // policyTitle: new FormControl(null),
            policyGroup: new UntypedFormControl(null),
            yearsOfServiceStart: new UntypedFormControl(null),
            yearsOfServiceEnd: new UntypedFormControl(null),
            accrualPeriod: new UntypedFormControl(null),
            hoursAccrued: new UntypedFormControl(null),
            groupName: new UntypedFormControl(null),
            selectpolicy: new UntypedFormControl(null),
            addpolicy: new UntypedFormControl(null),
            vacationaccrualmax: new UntypedFormControl(null)
        });
    }
    ngOnDestroy() {
        this.active = false;
    }

    ngOnInit(): void {
        this.setupSubscriptions();
        this.buttonItems = [
            {
                label: 'Policy Title Group Name',
                command: () => {
                    this.showGroupNameInput = false;
                    this.addGroup();
                }
            },
            {
                label: 'Custom Group Name',
                command: () => {
                    this.showGroupNameInput = true;
                    this.customGroupOptionSelected = true;
                }
            }
        ];
    }

    setupSubscriptions() {
        this.addFormGroup.controls['selectpolicy'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.addFormGroup.controls['addpolicy'].patchValue(null);
                    this.customGroupName = null;
                }
            });
        this.addFormGroup.controls['addpolicy'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.addFormGroup.controls['selectpolicy'].patchValue(null);
                    this.customGroupOptionSelected = true;
                }
            });
        this.addFormGroup.controls['policyGroup'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.policyGroup = value;
                    this.policyGroupInvalid = false;
                }
            });
        this.addFormGroup.controls['yearsOfServiceStart'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null || value != '') {
                    this.yearsOfServiceStart = value;
                    this.yearsOfServiceStartInvalid = false;
                }
            });
        this.addFormGroup.controls['yearsOfServiceEnd'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null || value != '') {
                    this.yearsOfServiceEnd = value;
                    this.yearsOfServiceEndInvalid = false;
                }
            });
        this.addFormGroup.controls['accrualPeriod'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.accrualPeriod = value;
                    this.accrualPeriodInvalid = false;
                }
            });
        this.addFormGroup.controls['hoursAccrued'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null || value != '') {
                    this.hoursAccrued = value;
                    this.hoursAccruedInvalid = false;
                }
            });
        this.addFormGroup.controls['vacationaccrualmax'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null || value != '') {
                    this.vacAccrualMax = value;
                    this.vacAccrualMaxInvalid = false;
                }
            });
        this.addFormGroup.controls['groupName'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null || value != '') {
                    this.customGroupName = value;
                }
            });
    }

    addPolicyClicked() {
        this.addFormGroup.controls['selectpolicy'].patchValue('selectpolicy');
        this.showDialog = true;
    }

    onEditInit($event: { data: PtoPolicySetup }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: PtoPolicySetup) {
        this.clonedPolicySetup[rowData.Policyid] = { ...rowData };
        this.editing = rowData;
        this.log.verbose('onRowEditInit');
    }

    onRowEditSave(rowData: PtoPolicySetup) {
        this.SavePolicySetup.next(rowData);
        delete this.clonedPolicySetup[rowData.Policyid];
        delete this.editing;
        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: PtoPolicySetup) {
        delete this.clonedPolicySetup[item.Policyid];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }

    deleteClicked(rowData) {
        this.dataForDelete = rowData;
        this.showDeleteDialog = true;
        this.areYouSureDeleteDesc = `Are you sure you want to delete this policy criteria with ${this.dataForDelete.PolicyCriteriaEmpCnt} employees assigned?`;
    }

    confirmDelete() {
        this.DeletePolicySetup.next(this.dataForDelete);
        this.showDeleteDialog = false;
    }

    addGroup() {
        this.customGroupOptionSelected = false;
        // this.addGroupInvalid = false;
        if (this.showGroupNameInput == true) {
            this.newGroup = [
                {
                    Categoryid: 'PUBLIC000000000000000000000000000000',
                    GroupName: this.customGroupName,
                    Purpose: '',
                    GroupID: -1
                }
            ];
        }

        this.store.dispatch(new UpdateGroups(this.newGroup));

        // this.showGroupNameInput = false;
    }

    addPolicy() {
        if (this.customGroupName != null) {
            this.customGroupOptionSelected = true;
        } else {
            this.customGroupOptionSelected = false;
        }
        if (this.customGroupOptionSelected == true) {
            if (this.customGroupName == null || this.customGroupName == '') {
                this.addGroupInvalid = true;
            }
            if (this.policyTitle == null || this.policyTitle == '') {
                this.policyTitleInvalid = true;
            }
            if (
                this.yearsOfServiceStart == null ||
                this.yearsOfServiceStart == ''
            ) {
                this.yearsOfServiceStartInvalid = true;
            }
            if (
                this.yearsOfServiceEnd == null ||
                this.yearsOfServiceEnd == ''
            ) {
                this.yearsOfServiceEndInvalid = true;
            }
            if (this.accrualPeriod == null) {
                this.accrualPeriodInvalid = true;
            }
            if (this.hoursAccrued == null || this.hoursAccrued == '') {
                this.hoursAccruedInvalid = true;
            }
            if (this.vacAccrualMax == null || this.vacAccrualMax == '') {
                this.vacAccrualMaxInvalid = true;
            }

            if (
                this.addGroupInvalid ||
                this.yearsOfServiceStartInvalid ||
                this.yearsOfServiceEndInvalid ||
                this.accrualPeriodInvalid ||
                this.hoursAccruedInvalid ||
                this.vacAccrualMaxInvalid
            ) {
                return;
            } else {
                this.addGroup();
                setTimeout(() => {
                    if (
                        this.groups.findIndex(
                            x => x.GroupName == this.customGroupName
                        ) != -1
                    ) {
                        this.policyGroup = this.groups.find(
                            x => x.GroupName == this.customGroupName
                        ).GroupID;
                        // if (this.groupsSelectItem.length > 0) {
                        //     this.addFormGroup.controls[
                        //         'policyGroup'
                        //     ].patchValue(
                        //         this.groups.find(
                        //             x => x.GroupName == this.customGroupName
                        //         ).GroupID
                        //     );
                        //     this.policyGroup = this.groups.find(
                        //         x => x.GroupName == this.customGroupName
                        //     ).GroupID;
                        // } else {
                        //     this.addFormGroup.controls[
                        //         'policyGroup'
                        //     ].patchValue(this.groupsSelectItem[0].value);
                        // }
                    }
                    if (
                        this.policyGroup &&
                        this.yearsOfServiceStart &&
                        this.yearsOfServiceEnd &&
                        this.accrualPeriod &&
                        this.hoursAccrued &&
                        this.vacAccrualMax
                    ) {
                        this.SavePolicySetup.next({
                            Policyid: -1,
                            PolicyTitle: this.customGroupName
                                ? this.customGroupName
                                : this.groups.find(
                                      x => x.GroupID == this.policyGroup
                                  ).GroupName,
                            Groupid: this.policyGroup,
                            YearsOfServiceStart: this.yearsOfServiceStart,
                            YearsOfServiceCeiling: this.yearsOfServiceEnd,
                            AccrualPeriodID: this.accrualPeriod,
                            HoursAccrued: this.hoursAccrued,
                            vacationaccrualmax: this.vacAccrualMax
                        });
                        this.clearDialog();
                    }
                }, 500);
            }
        } else {
            if (
                this.policyGroup &&
                this.yearsOfServiceStart &&
                this.yearsOfServiceEnd &&
                this.accrualPeriod &&
                this.hoursAccrued &&
                this.vacAccrualMax
            ) {
                this.SavePolicySetup.next({
                    Policyid: -1,
                    PolicyTitle: this.customGroupName
                        ? this.customGroupName
                        : this.policySetup.find(
                              x => x.Groupid == this.policyGroup
                          ).PolicyTitle,
                    Groupid: this.policyGroup,
                    YearsOfServiceStart: this.yearsOfServiceStart,
                    YearsOfServiceCeiling: this.yearsOfServiceEnd,
                    AccrualPeriodID: this.accrualPeriod,
                    HoursAccrued: this.hoursAccrued,
                    vacationaccrualmax: this.vacAccrualMax
                });
                this.clearDialog();
            } else {
                if (this.policyTitle == null || this.policyTitle == '') {
                    this.policyTitleInvalid = true;
                }
                if (this.policyGroup == null) {
                    this.policyGroupInvalid = true;
                }
                if (
                    this.yearsOfServiceStart == null ||
                    this.yearsOfServiceStart == ''
                ) {
                    this.yearsOfServiceStartInvalid = true;
                }
                if (
                    this.yearsOfServiceEnd == null ||
                    this.yearsOfServiceEnd == ''
                ) {
                    this.yearsOfServiceEndInvalid = true;
                }
                if (this.accrualPeriod == null) {
                    this.accrualPeriodInvalid = true;
                }
                if (this.hoursAccrued == null || this.hoursAccrued == '') {
                    this.hoursAccruedInvalid = true;
                }
                if (this.vacAccrualMax == null || this.vacAccrualMax == '') {
                    this.vacAccrualMaxInvalid = true;
                }
            }
        }
    }

    clearDialog() {
        this.policyTitleInvalid = false;
        this.policyGroupInvalid = false;
        this.yearsOfServiceStartInvalid = false;
        this.yearsOfServiceEndInvalid = false;
        this.accrualPeriodInvalid = false;
        this.hoursAccruedInvalid = false;
        this.vacAccrualMaxInvalid = false;
        this.addGroupInvalid = false;

        this.customGroupName = null;

        // this.addFormGroup.controls['policyTitle'].reset();
        this.addFormGroup.controls['policyGroup'].reset();
        this.addFormGroup.controls['yearsOfServiceStart'].reset();
        this.addFormGroup.controls['yearsOfServiceEnd'].reset();
        this.addFormGroup.controls['accrualPeriod'].reset();
        this.addFormGroup.controls['hoursAccrued'].reset();
        this.addFormGroup.controls['groupName'].reset();
        this.addFormGroup.controls['vacationaccrualmax '].reset();
    }

    closeDialog() {
        this.showDialog = false;
        // this.showGroupNameInput = false;

        this.policyTitleInvalid = false;
        this.policyGroupInvalid = false;
        this.yearsOfServiceStartInvalid = false;
        this.yearsOfServiceEndInvalid = false;
        this.accrualPeriodInvalid = false;
        this.hoursAccruedInvalid = false;
        this.vacAccrualMaxInvalid = false;
        this.addGroupInvalid = false;

        // this.addFormGroup.controls['policyTitle'].reset();
        this.addFormGroup.controls['policyGroup'].reset();
        this.addFormGroup.controls['yearsOfServiceStart'].reset();
        this.addFormGroup.controls['yearsOfServiceEnd'].reset();
        this.addFormGroup.controls['accrualPeriod'].reset();
        this.addFormGroup.controls['hoursAccrued'].reset();
        this.addFormGroup.controls['groupName'].reset();
        this.addFormGroup.controls['vacationaccrualmax '].reset();
    }

    findGroupName(rowData) {
        let groupName;
        if (this.groups.length > 0) {
            groupName = this.groups.find(
                x => x.GroupID == rowData.Groupid
            ).GroupName;
            return groupName;
        }
    }

    findAccrualPeriod(rowData) {
        let accrualPeriod;
        if (this.accrualPeriods && this.accrualPeriods.length > 0) {
            accrualPeriod = this.accrualPeriods.find(
                x => x.AccrueLeavePeriodID == rowData.AccrualPeriodID
            ).AccrueLeavePeriod;
            return accrualPeriod;
        }
    }

    tableFilter($event, type) {
        if (type == 'policytitle') {
            this.SetupTable.filter($event.value, 'PolicyTitle', 'in');
        }
        if (type == 'accrualperiod') {
            this.SetupTable.filter($event.value, 'AccrualPeriod', 'in');
        }
    }
}
